import { ref } from 'vue';

const getExportlistEmployees = () => {
    const exportlistEmployees_error = ref(null);
    const exportlistEmployees = ref(null);
    const exportExportlistEmployees_error = ref(null);

    const loadExportlistEmployees = async (employers, teams, locations) => {
        var params = [];
        params.push(['locations', locations]);
        params.push(['employers', employers]);
        params.push(['teams', teams]);
        //console.log("api getEmployers: " , employers);
        //console.log("api getEmployers: " , params);
        try {
            //console.log("api getEmployers: " , new URLSearchParams(params));
            let data = await fetch("/api/employees/export?" + new URLSearchParams(params));
            
            console.log("data emplExp: " ,data);
            if (!data.ok) {
                throw Error("Can't load data");
            }

            exportlistEmployees.value = await data.json();

            // console.log("oimApp: " , oimAppointments.value);
        } catch (err) {
            exportlistEmployees_error.value = err.message;
        }
    };

    return { exportlistEmployees, exportlistEmployees_error, loadExportlistEmployees };
}

export default getExportlistEmployees;
